import React, { useState, useEffect } from "react";
import { signUp } from "@aws-amplify/auth";
import { Link, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Layout from "../layout/Layout";
import toastr from "toastr";
import "toastr/build/toastr.min.css"; // Import Toastr CSS

const RegisterPage = () => {
  const [fullname, setFullname] = useState("");
  const [mobileno, setMobileno] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };
  useEffect(() => {
    document.title = "Signup | HRMA";
  }, []);
  const handleRegister = async (e) => {
    e.preventDefault();

    // Ensure all required fields are present
    if (!fullname || !mobileno || !email || !password || !confirmPassword) {
      toastr.error("All fields are required");
      return;
    }

    // Check if passwords match
    if (password !== confirmPassword) {
      toastr.error("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      // API call to check if the user already exists
      const formData = new FormData();
      formData.append("email", email);
      formData.append("mobileno", mobileno);
      formData.append("fullname", fullname);
      formData.append("password", password);

      const response = await fetch(`${process.env.REACT_APP_CHECK_USER_API}/api/auth/signup`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok || data.exists) {
        toastr.error(data.message || "User already exists");
        return;
      }

      // Amplify signup call
      await signUp({
        username: email,
        password,
        options: {
          userAttributes: {
            email,
            "custom:isAdmin": "false",
            "custom:isApprover": "false",
            "custom:isUser": "true",
          },
        },
      });

      toastr.success("Signup successful! Please confirm your email.");
      navigate("/confirm-email", { state: { email, fullname, mobileno, password } });
    } catch (error) {
      toastr.error(error.message || "Something went wrong during sign-up.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title={"Signup - HRMA"}>
      <div className="container-fluid">
        <div className="row w-100 h-100">
          {/* Left Section */}
          <div className="col-lg-8 left-section d-flex align-items-center justify-content-center" style={{ backgroundColor: "#f9f9f9" }}>
            <div className="text-center">
              <img
                src="/images/login.png"
                alt="3D Illustration"
                className="img-fluid"
                style={{ maxWidth: "70%" }}
              />
            </div>
          </div>

          {/* Right Section */}
          <div className="col-lg-4 right-section d-flex align-items-center">
            <div className="form-container p-4 w-100">
              <h3 className="text-center">Create an Account</h3>
              <p className="text-center text-muted">Please sign up to start your journey</p>

              <form onSubmit={handleRegister}>
                <div className="mb-3">
                  <input
                    type="text"
                    id="fullname"
                    className="form-control"
                    placeholder="Full Name"
                    autoComplete="off"
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <input
                    type="tel"
                    id="mobileno"
                    className="form-control"
                    placeholder="Mobile Number"
                    autoComplete="off"
                    value={mobileno}
                    onChange={(e) => setMobileno(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <input
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Email"
                    autoComplete="off"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <div className="input-group">
                    <input
                      type={passwordVisible ? "text" : "password"}
                      id="password"
                      className="form-control"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={togglePasswordVisibility}
                    >
                      {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <input
                    type="password"
                    id="confirmPassword"
                    className="form-control"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-Login-Signup w-100 btn-primary"
                  disabled={loading}
                >
                  {loading ? "Please Wait..." : "REGISTER"}
                </button>
              </form>

              <p className="mt-4 text-center">
                Already have an account? {" "}
                <Link to="/login" className="primary-text">
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RegisterPage;
